module.exports = __webpack_public_path__ + "img/writing.3815d0f0.jpeg";